import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZendComponent } from './simple-icons-zend.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZendComponent ],
    exports:      [ SimpleIconsZendComponent ],
    bootstrap:    []
})
export class SimpleIconsZendModule {}
